export default {
  INVOICE: {
    label: 'Número da fatura',
    placeholder: 'Informe uma ou mais faturas',
  },
  PRE_INVOICE: {
    label: 'Número da pré-fatura',
    placeholder: 'Informe uma ou mais pré-faturas',
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-recon/features/invoice/enum/invoice-type-fields.enum.js